import styled, { css } from 'styled-components';
import { colors } from '../../../theme/colors';

const getFontFamily = (props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif';
const getFontSizeSm = (props) => (props.theme && props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px';
const getFontSizeMd = (props) => (props.theme && props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.md) || '16px';
const getTextSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.secondary) || '#666';
const getTextMuted = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#ccc';
const getBrandPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || colors.brandDarkBlue;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TopControls = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
  align-items: center;
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: ${props => getFontFamily(props)};
  font-size: ${props => getFontSizeSm(props)};
  color: ${props => getTextSecondary(props)};

  select {
    padding: 0.25rem 0.5rem;
    border: 1px solid ${props => getTextMuted(props)};
    border-radius: 4px;
    background-color: #fff;
    color: ${props => getBrandPrimary(props)};
    outline: none;
    font-size: ${props => getFontSizeSm(props)};

    &:focus {
      border-color: ${props => getBrandPrimary(props)};
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
  gap: 0.25rem;
  font-family: ${props => getFontFamily(props)};
`;

export const PageButton = styled.button`
  background: ${props => (props.active ? colors.primary : '#fff')};
  color: ${props => (props.active ? '#fff' : colors.brandDarkBlue)};
  border: 1px solid ${props => (props.active ? colors.primary : colors.brandLightGray)};
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  font-size: ${props => getFontSizeSm(props)};
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${props => (props.active ? colors.primary : colors.brandOffWhite)};
    color: ${props => (props.active ? '#fff' : colors.brandDarkBlue)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06);
  border: 1px solid #EAECF0;
  margin-bottom: 1.5rem;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-family: ${props => getFontFamily(props)};
`;

export const TableHeader = styled.thead`
  background-color: #F9FAFB;
  border-bottom: 1px solid #EAECF0;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #EAECF0;

  ${props => props.hover && css`
    &:hover {
      background-color: #F9FAFB;
    }
  `}

  ${props => props.striped && css`
    &:nth-child(even) {
      background-color: #F9FAFB;
    }
  `}
  
  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.td`
  padding: 16px 24px;
  font-size: ${props => getFontSizeSm(props)};
  color: #475467;
  vertical-align: middle;
`;

export const TableHeaderCell = styled.th`
  padding: 12px 24px;
  font-size: ${props => getFontSizeMd(props)};
  font-weight: 700;
  color: #475467;
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #EAECF0;
  background: white;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const LeftControls = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
`;

export const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #EAECF0;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  width: 260px;
  background: white;
  gap: 0.5rem;

  i {
    color: #667085;
    font-size: 0.875rem;
  }

  input {
    border: none;
    outline: none;
    width: 100%;
    font-size: ${props => getFontSizeSm(props)};
    color: #101828;
    font-family: inherit;

    &::placeholder {
      color: #667085;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Table/components/TableStyles.js